import template from './general-business-actuals.html';
import controller from './general-business-actuals.controller';

let generalBusinessActualsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default generalBusinessActualsComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/general-business-actuals/general-business-actuals.component.js